import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=3adc4c94&scoped=true"
import script from "./AttachmentsList.vue?vue&type=script&lang=ts"
export * from "./AttachmentsList.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentsList.vue?vue&type=style&index=0&id=3adc4c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc4c94",
  null
  
)

export default component.exports